export default {
    data() {
        return {
            canSearchCpf: true,
        }
    },
    methods: {
        async searchCpf(cpf) {
            this.loading = true;

            await axios.get('/webservice-information/search-cpf', {
                params: {
                    cpf: cpf
                }
            })
                .then((response) => {
                    let result = response.data;
                    this.form.social_name = result.name;
                })
                .catch(() => {
                    this.form.social_name = null;
                })
                .finally(() => this.loading = false)
        },

        async changeCpfInput(event) {
            let cpf = event.target.value
                .replace('.', '')
                .replace('.', '')
                .replace('-', '');

            if (cpf !== this.form.document) {
                this.form.document = cpf;

                if (cpf.length === 11 && this.form.document_type === 'CPF' && this.canSearchCpf) {
                    await this.searchCpf(cpf);
                }
            }
        },
    }
}
